import React, { memo } from 'react';
import { IconWithTooltip } from '../../../../globalUtils/globalIcons';
import ExecutionLogCard from './ExecutionLogCard';
import './remoteCommandExecutionLogs.css';

export type ExecutionStatus = 'NotPerformed' | 'NotStarted' | 'InProgress' | 'Completed' | 'Timeout';
export type CommandScope = 'Charger' | 'Connector' | 'SMR';
export type CommandStatus = 'Idle' | 'Downloading' | 'Downloaded' | 'DownloadFailed' | 'Installing' | 'Installed' | 'InstallFailed' |
  'Uploading' | 'Uploaded' | 'UploadFailed' | 'CommandFailed';
export type CommandResult = 'Pending' | 'In Progress' | 'Success' | 'Failed';
export type ChipVariant = 'pending' | 'in-progress' | 'success' | 'failed' | 'completed' | 'not-performed';

export interface IRemoteCommandExecutionUnit {
  id: string;
  deviceType: string;
  unitNumber: number;
  commandStatus: CommandStatus;
  failureReason: string | null;
  startedAt: string | null;
  completedAt: string | null;
}

export interface IRemoteCommandExecution {
  id: string;
  commandExecutionId: string;
  remoteCommand: string;
  requestedBy: 'RMS' | 'CMS' | 'Local' | 'Unknown';
  executionStatus: ExecutionStatus;
  executionPercentage: number;
  commandType: 'Firmware' | 'ConfigFiles' | 'SslCertificates' | 'Logs';
  scope: CommandScope;
  commandStatus: CommandStatus;
  failureReason: string | null;
  initiatedBy: string | null;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  finishedUnits: number;
  totalUnits: number;
  units: IRemoteCommandExecutionUnit[];
}

export interface IRemoteCommandExecutionLogs {
  currentExecution: IRemoteCommandExecution | null;
  mostRecentExecution: IRemoteCommandExecution | null;
}

interface RemoteCommandExecutionLogsProps extends IRemoteCommandExecutionLogs {
  isLogsLoaded: boolean;
  commandLabel: string;
  targetLabel: string;
}

function RemoteCommandExecutionLogs({ currentExecution, mostRecentExecution, isLogsLoaded, commandLabel, targetLabel }: RemoteCommandExecutionLogsProps) {
  return (
    <div className='remote__command__logs'>
      <div className='remote__command__logs-header'>
        <span className='remote__command__logs-title'>Command Execution Logs</span>
        <IconWithTooltip iconClassName='rms_info_icon' toolTipText={'Shows the current and the most recent execution of the selected command on this charger, whether requested from RMS, CMS or locally.'} containerClassName='remote__command__logs-info' />
      </div>

      {isLogsLoaded &&
        <div className='remote__command__logs-cards'>
          <ExecutionLogCard title='Current Execution' commandLabel={commandLabel} targetLabel={targetLabel} execution={currentExecution} />
          {mostRecentExecution &&
            <ExecutionLogCard title='Most Recent Execution' commandLabel={commandLabel} targetLabel={targetLabel} execution={mostRecentExecution} />
          }
        </div>
      }
    </div>
  );
}

export default memo(RemoteCommandExecutionLogs);
